<template>
  <div>
    <h3 style="text-align: center;">客户评价</h3>
    <div class="home" v-if="!isShow">
      <div class="list">
      <div>
        请您对本次服务进行评价
      </div>
      <div style="margin-top:10px">
        <el-radio v-model="radio" label="1">非常满意</el-radio>
        <el-radio v-model="radio" label="2">满意</el-radio>
        <el-radio v-model="radio" label="5">不满意</el-radio>
      </div>
    </div>
    <!-- <div class="list">
      <div>
        请问本次服务上门是否及时?
      </div>
      <div style="margin-top:10px">
        <el-radio v-model="radio2" label="1">及时</el-radio>
        <el-radio v-model="radio2" label="0">不及时</el-radio>
      </div>
    </div> -->
    <!-- <div class="list">
      <div>
        请问本次服务是否解决了您的问题?
      </div>
      <div style="margin-top:10px">
        <el-radio v-model="radio3" label="1">已解决</el-radio>
        <el-radio v-model="radio3" label="0">未解决</el-radio>
      </div>
    </div> -->
      <div class="content">
        <div>评价内容</div>
        <div style="margin: 10px 0;"></div>
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          maxlength="250"
          show-word-limit
        ></el-input>
        <div style="margin: 10px 0 10px 0;">上传图片</div>
        <div>
          <!-- {'content-type':'multipart/form-data'} -->
          <el-upload ref="picList" :class="{uoloadSty:showBtnDealImg,disUoloadSty:noneBtnImg}"
                :headers="token" :data="{ type: 4 }" 
                :action="apiUrl" :file-list="fileList" 
                multiple :limit="limitCountImg" :before-upload="picListBeforeUpload" 
                :on-success="handleAvatarSuccess" :on-exceed='checkLength'
                :on-remove="handleDealImgRemove" :on-change="dealImgChange"
                :before-remove="handleRemove" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    支持上传格式：png、jpg、jpeg,图片大小建议10M以内,最多上传九张图片,图片显示即为上传成功。
                  </div>
            </el-upload>
        </div>
      </div>
      <div v-if="isBotton">
        <el-button type="primary" @click="uploads" style="margin-top:10px;width:100%">完成评价</el-button>
      </div>
      <div class="footer">
        <span>客服电话:67286728</span>
      </div>
    </div>
    <div class="home" v-else>
      <div class="homeContent">
        <div class="layout">
          <div style="width:40%;line-height:28px;">服务评价:</div>
          <div style="width:60%">
            <el-button v-if="this.detailList.evaluate==1" type="success" round size="mini">非常满意</el-button>
            <el-button v-if="this.detailList.evaluate==2" type="primary" round size="mini">满意</el-button>
            <el-button v-if="this.detailList.evaluate==5" type="danger" round size="mini">不满意</el-button>
          </div>
        </div>
        <!-- <el-divider style="height:10px" :margin="12"></el-divider>
        <div class="layout">
          <div style="width:40%;line-height:28px;">上门是否及时:</div>
          <div style="width:60%">
            <el-button v-if="this.detailList.isInTime==1" type="success" round size="mini">及时</el-button>
            <el-button v-if="this.detailList.isInTime==0" type="danger" round size="mini">不及时</el-button>
          </div>
        </div>
        <el-divider style="height:10px" :margin="12"></el-divider>
        <div class="layout">
          <div style="width:40%;line-height:28px;">是否解决问题:</div>
          <div style="width:60%">
            <el-button v-if="this.detailList.isSolve==1" type="success" round size="mini">已解决</el-button>
            <el-button v-if="this.detailList.isSolve==0" type="danger" round size="mini">未解决</el-button>
          </div>
        </div> -->
        <el-divider style="height:10px" :margin="12"></el-divider>
        <span>评价内容:</span>
        <div style="margin: 10px 0;font-size:12px">{{this.detailList.evaluateContent}}</div>
        <el-divider style="height:10px" :margin="12"></el-divider>
        <span>图片:</span>
        <div>
          <el-image style="width: auto; height: 100px;width: 100px;margin:5px"
           v-for="(src, index) in imgList" :src="src" fit="cover" :key="index" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveOrdEvaluate, selectOrdEvaluateDetail } from "@/api/index";
import { getUrl } from "@/utils/request";
import { getToken } from "@/utils/auth";
export default {
  name: "HomeView",
  components: {
    // HelloWorld
  },
  data() {
    return {
      token: {
        Authorization: getToken(),
      },
      // apiUrl:'https://testpingjia.67286728.com/testfile/apiCommon/file/fileUpload',//测试 ---测试用
      apiUrl:'https://pingjia.67286728.com/file/apiCommon/file/fileUpload',//测试 ---测试用 生产
      imgUrls: [],
      showBtnDealImg:true,
      noneBtnImg:false,
      isShow: false,
      limitCountImg:9,
      fileList: [],
      picListfileList: [],
      radio: '1',
      radio2: '1',//放开默认为1
      radio3: '1',//放开默认为1
      evaluateList: {
        id: "",
        evaluate: "1",
        isInTime: "1",
        isSolve: "1",
        evaluateContent:"",
        evaluateImg: []
      },
      textarea: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      detailList: "" ,//获取详情渲染列表
      imgList: [],//获取详情渲染列表
      isBotton:true,
      isUpLoad:false,

    };
  },
  created() {
    this.evaluateList.id = this.$route.query.id?this.$route.query.id:false
    this.search();
  },
  methods: {
    onOversize() {},
    onReadProperty() {},
    beforeRead() {},
    search() {
      let id = {
        id: this.evaluateList.id
      };
      if(this.evaluateList.id==false){
        this.$message({
            type: "info",
            message: "您暂无评价"
          });
          this.isBotton=false
      }else{
        selectOrdEvaluateDetail(id)
        .then(res => {
          if (res.code == 0) {
            this.detailList = res.data;
            if(this.detailList){
              if (this.detailList.evaluateImg) {
                this.imgList=this.detailList.evaluateImg.split(","); //有值显示已评价页面
               }
               if (this.detailList.evaluate) {
                  this.isShow = true; //有值显示已评价页面
               }
            }
           
          }
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: err.message
          });
        });
      }
      
    },
    uploads() {

      this.evaluateList.evaluate=this.radio
      this.evaluateList.isInTime=this.radio2
      this.evaluateList.isSolve=this.radio3
      this.evaluateList.evaluateContent=this.textarea
      this.evaluateList.evaluateImg=this.imgUrls.map(res=>{
      //  return  res =res.substring(22,res.length)//测试地址22位
       return  res =res.substring(19,res.length) //生产 19位
      })
      console.log(this.evaluateList.evaluateImg,"点击评价 图片地址");
      if(this.isUpLoad){//上传图片
        if(this.evaluateList.evaluateImg.length>0){
          saveOrdEvaluate(this.evaluateList).then(res => {
            if(res.code==0){
              this.$message.success("成功"); 
              this.search()
            }
          });
        }else{
          this.$message.error("图片未上传成功,请重试");
        }

      }else{//未上传图片直接评价
          saveOrdEvaluate(this.evaluateList).then(res => {
            if(res.code==0){
              this.$message.success("成功"); 
              this.search()
            }
          });
      }
 
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    dealImgChange(file, fileList){
      this.noneBtnImg = fileList.length >= this.limitCountImg;
      this.isUpLoad=true//触发了
    },
    handleDealImgRemove(file,fileList){
      this.noneBtnImg = fileList.length >= this.limitCountImg;
      if(fileList.length<1){//已删除所有图片
        this.isUpLoad=false
      }
    },
    picListBeforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      let isRightSize = file.size / 1024 / 1024 < 10;
      if (!isRightSize) {
        this.$message.error("文件大小超过 10MB");
      }
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
      }
      return isRightSize && isJPG;
    },
    handleRemove(file, list) {
      this.imgUrls.map((i, index) => {
        if (i == file.url || (file.response && i == file.response.data)) {
          this.imgUrls.splice(index, 1);
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.imgUrls.push(res.data);
    },
    checkLength(files, fileList){
      let data=Number(files.length)+Number(fileList.length)
      if(data>9){
        this.$message.error("您选择的图片超过了限制,一共只能上传九张图片"); 
      }
      
    },
  }
};
</script>
<style lang="less">
#id{
  width: 100px !important;
  height: 100px !important;
}
.home {
  padding: 10px;
}
.homeContent {
  padding: 20px 10px 10px 10px;
  background: #fff;
}
.list {
  height: 55px;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 14px;
  // font-weight: bold;
  // color: #44434300;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.content {
  // height: 200px;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.footer {
  margin: 10px 0 20px 0;
  width: 100%;
  font-size: 10px;
  text-align: center;
}
.listConet {
  height: 55px;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 14px;
  // font-weight: bold;
  // color: #44434300;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.layout{
  display: flex;
}
/deep/.el-divider--horizontal {
  margin: 16px 0;
}
/deep/.el-upload--picture-card {
  height: 100px;
  width: 100px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.uoloadSty .el-upload--picture-card{
  width:100px;
  height:100px;
  line-height:100px;
}
.disUoloadSty .el-upload--picture-card{
  display:none;   /* 上传按钮隐藏 */
}
::v-deep .el-upload {
  width: 100px!important;
  height: 100px!important;
  line-height: 100px!important;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px!important;
  height: 100px!important;
  line-height: 100px!important;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px!important;
  height: 100px!important;
  line-height: 100px!important;
}
::v-deep .avatar {
  width: 100px!important;
  height: 100px!important;
  
}
</style>
